export function containsExpressCheckout(addressName) {
  return addressName?.startsWith('ExpressCheckout');
}
